import axios from "axios";
import { apiClient } from "./client";

// Phone (971XXXXXXXXX) or email, whichever the user signed up with
export type Identifier = { phone: string } | { email: string };

export type VerifyResult = {
    token: string;
    pendingDeletion: boolean;
    scheduledFor: string | null;
};

const auth = (token: string) => ({
    headers: { Authorization: `Bearer ${token}` },
});

export const sendDeletionOtp = (identifier: Identifier) =>
    apiClient.post("/account-deletion/send-otp", identifier);

export const verifyDeletionOtp = async (
    identifier: Identifier,
    code: string,
): Promise<VerifyResult> => {
    const res = await apiClient.post("/account-deletion/verify-otp", {
        ...identifier,
        code,
    });
    return res.data.data;
};

export const confirmDeletion = async (
    token: string,
    reason?: string,
): Promise<{ scheduledFor: string }> => {
    const res = await apiClient.post(
        "/account-deletion/confirm",
        { reason },
        auth(token),
    );
    return res.data.data;
};

export const cancelDeletion = (token: string) =>
    apiClient.post("/account-deletion/cancel", {}, auth(token));

// Maps an API failure to a key under delete_account.errors.
// A 400 only means "wrong code" on verify; elsewhere pass "generic".
export const errorKey = (error: unknown, badRequest = "invalid_code") => {
    const status = axios.isAxiosError(error) ? error.response?.status : 0;
    switch (status) {
        case 400:
            return badRequest;
        case 401:
            return "session_expired";
        case 409:
            return "active_orders";
        case 410:
            return "code_expired";
        case 429:
            return "too_many";
        default:
            return "generic";
    }
};
